import React, { useContext } from 'react';
import TextField from '@mui/material/TextField';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/en-gb';
import { ContextUserProfile } from '../../../contexts/UserProfileContext';
import '../../../stylesheets/stylesComponents/dateRangeFilter.scss';
import { styled } from '@mui/material/styles';
import styles from '../../../stylesheets/variables.scss';
import { capitalizeSentence } from '../../../utils/usefulFunctions';
import dayjs from 'dayjs';

const StyledTextField = styled(TextField)(() => ({
    '& label.Mui-focused': {
        color: styles.jungleGreen,
        boxShadow: 'unset !important;',
    },
    '& .MuiOutlinedInput-root': {
        '&:hover fieldset': {
            borderColor: styles.jungleGreen,
            boxShadow: 'unset !important;',
        },
        '&.Mui-focused fieldset': {
            borderColor: styles.jungleGreen,
            boxShadow: 'unset !important;',
        },
    },
}));

const DateRangeFilter = ({
    value,
    id,
    onChange,
    label,
    fromInputProps,
    toInputProps,
    helperText,
    gap = '10px',
    ...restProps
}) => {
    const { language, translate } = useContext(ContextUserProfile);

    const startText = `${capitalizeSentence(translate(label))} ${translate(
        'from'
    )}`;
    const endText = translate('to');

    const [valueFrom, valueTo] = value;

    const handleFromChange = newValue => {
        onChange({
            target: {
                name: id,
                value: [newValue, valueTo],
            },
        });
    };

    const handleToChange = newValue => {
        onChange({
            target: {
                name: id,
                value: [valueFrom, newValue],
            },
        });
    };

    const convertDateToDayjs = date => {
        if (!date) return date;
        return dayjs(date);
    };

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={language}
        >
            {/* classname used for targetting styles inside datePicker component => mui*/}
            <div
                style={{ display: 'flex', gap }}
                className='date-range-filter__container'
            >
                <DatePicker
                    slotProps={{ textField: { size: 'small' } }}
                    label={startText}
                    value={convertDateToDayjs(valueFrom)}
                    onChange={handleFromChange}
                    renderInput={params => (
                        <StyledTextField
                            {...params}
                            autoComplete='off'
                            {...fromInputProps}
                        />
                    )}
                    {...restProps}
                />
                <DatePicker
                    slotProps={{ textField: { size: 'small' } }}
                    label={endText}
                    value={convertDateToDayjs(valueTo)}
                    onChange={handleToChange}
                    renderInput={params => (
                        <StyledTextField
                            {...params}
                            autoComplete='off'
                            {...toInputProps}
                        />
                    )}
                    {...restProps}
                />
            </div>
            <p style={{ height: '30px' }}>{helperText}</p>
        </LocalizationProvider>
    );
};

export default DateRangeFilter;
